import { render, staticRenderFns } from "./SlotContainer.vue?vue&type=template&id=3bccb8ba"
import script from "./SlotContainer.vue?vue&type=script&lang=ts"
export * from "./SlotContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports